import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import CART_CONSTANTS from '../constants/cart';
import getDefaultCartState from './default_states/cart';

class CartStoreClass extends ReduceStore {
    getInitialState() {
        return getDefaultCartState();
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CART_ACTION) {
            switch (action.type) {
            case CART_CONSTANTS.LOAD_CART_ACTION:
                state.loading = true;
                state.loadingError = false;
                this.__emitChange();
                break;

            case CART_CONSTANTS.CART_LOADED_ACTION:
                state.loading = false;
                // _.merge(state, action.payload);
                Object.assign(state, action.payload);
                this.__emitChange();
                break;

            case CART_CONSTANTS.CART_LOADED_ERROR_ACTION:
                state.loading = false;
                state.loadingError = true;
                this.__emitChange();
                break;
            }
        }

        return state;
    }
}

const CartStore = new CartStoreClass(Dispatcher);
export default CartStore;
